module.exports = __webpack_public_path__ + "/img/0004ea33778d5a69272bdb0391e11caf.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/client/assets/appimg/ads_bg.jpg
 ** module id = 27
 ** module chunks = 0 4 5
 **/